import constants from './constants'

export default {
  AUTH_ROUTERS: [
    {
      name: 'SPLASH',
      path: '/',
      element: 'Splash',
    },
    {
      name: 'AUTHENTICATE',
      path: '/authenticate',
      element: 'Authenticate',
    },
    {
      name: 'SETTING_DB',
      path: '/setting-db',
      element: 'SettingDB',
      not_auth: true
    },
    {
      name: 'SIGN_IN',
      path: '/sign-in',
      element: 'SignIn',
      not_auth: true
    },
    {
      name: 'SIGN_UP',
      path: '/sign-up',
      element: 'SignUp',
      not_auth: true
    },
    {
      name: 'CHANGE_INFORMATION',
      path: '/change-information',
      element: 'ChangeInformation'
    },
    {
      name: 'OTP_CODE',
      path: '/otp-code',
      element: 'OtpCode',
    },
  ],

  ERROR_ROUTERS: [
    {
      name: '404',
      path: '/errors/404',
      element: 'Error404',
      not_auth: true
    },
    {
      name: '403',
      path: '/errors/403',
      element: 'Error403',
      not_auth: true
    }
  ],

  ADMIN_ROUTERS: [
    {
      name: 'ADMIN_ERROR',
      path: '/admin-error',
      element: 'AdminErrorPage',
    },
    {
      name: 'ACCOUNT_DETAILS',
      path: '/account-details',
      element: 'AccountDetails',
      label: "account_details.title",
    },
    {
      name: 'ACCOUNT_CHANGE_PASSWORD',
      path: '/account-details/change-password',
      element: 'AccountChangePassword',
      parent: 'ACCOUNT_DETAILS',
      label: "change_password.title",
    },
    {
      name: 'ACCOUNT_2FA',
      path: '/account-details/two-factor-authentication',
      element: 'Account2FA',
      parent: 'ACCOUNT_DETAILS',
      label: "2fa.title",
    },
    {
      name: 'ACCOUNT_UPDATE_ENCRYPTION',
      path: '/account-details/update-encryption',
      element: 'AccountUpdateEncryption',
      parent: 'ACCOUNT_DETAILS',
      label: "update_encryption.title",
    },
    {
      name: 'PROJECTS',
      element: 'Projects',
      path: '/workspaces/:workspace_id/projects',
      label: "projects.title",
    },
    {
      name: 'EVENTS',
      path: '/workspaces/:workspace_id/events',
      element: 'Events',
      label: "events.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      name: 'WORKSPACE_INFORMATION',
      path: '/workspaces/:workspace_id/information',
      element: 'Information',
      label: "information.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      name: 'WORKSPACE_MEMBERS',
      path: '/workspaces/:workspace_id/members',
      element: 'Members',
      label: "members.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      name: 'WORKSPACE_EMAIL_SETTING',
      path: '/workspaces/:workspace_id/email-setting',
      element: 'EmailSetting',
      label: "email_setting.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      name: 'WORKSPACE_IMPORT_EXPORT',
      path: '/workspaces/:workspace_id/import-export',
      element: 'ImportExport',
      label: "import_export.title",
      wsRoles: [
        constants.WS_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      name: 'PROJECT_SECRETS',
      path: '/workspaces/:workspace_id/projects/:project_id/secrets',
      element: 'ProjectSecrets',
      label: "secrets.title",
    },
    {
      name: 'PROJECT_ENVIRONMENTS',
      path: '/workspaces/:workspace_id/projects/:project_id/environments',
      element: 'ProjectEnvironments',
      label: "environments.title",
    },
    {
      name: 'PROJECT_LEAKED_SECRETS',
      path: '/workspaces/:workspace_id/projects/:project_id/leak-detection',
      element: 'ProjectLeakedSecrets',
      label: "leaked_secrets.title",
    },
    {
      name: 'PROJECT_ACCESS_KEY',
      path: '/workspaces/:workspace_id/projects/:project_id/access-key',
      element: 'ProjectAccessKey',
      label: "access_key.title",
    },
    {
      name: 'PROJECT_ACCESS_LOG',
      path: '/workspaces/:workspace_id/projects/:project_id/access-log',
      element: 'ProjectAccessLog',
      label: "access_log.title",
    },
    {
      name: 'PROJECT_INFO',
      path: '/workspaces/:workspace_id/projects/:project_id/info',
      element: 'ProjectInformation',
      label: "project_info.title",
      pRoles: [
        constants.PROJECT_MEMBER_ROLE.ADMIN,
      ],
    },
    {
      name: 'PROJECT_MEMBERS',
      path: '/workspaces/:workspace_id/projects/:project_id/members',
      element: 'ProjectMembers',
      label: "project_members.title",
      pRoles: [
        constants.PROJECT_MEMBER_ROLE.ADMIN,
      ],
    },
  ],
}
